import {
	dispatchAcknowledgedEvent,
	openResourceSection,
} from '../../core/resourceEvents';
import {
	SSID_FILTER_EVENT,
	SSID_FOCUS_EVENT,
	SSID_SECTION_EVENT,
} from './events';

const SECTIONS = new Set([
	'home.global_ssids',
	'site.ssids',
	'ap.ssids',
]);

/**
 * Open an SSID section.
 * @param {string} sectionId semantic section identifier
 * @return {Promise<void>} completion acknowledgement
 */
export function openSsidSection(sectionId) {
	return openResourceSection(SSID_SECTION_EVENT, sectionId, SECTIONS);
}

/**
 * Apply an SSID inventory query.
 * @param {string} query SSID query
 * @return {Promise<void>} completion acknowledgement
 */
export function applySsidFilter(query) {
	if (typeof query !== 'string' || !query.trim()) {
		return Promise.reject(new Error('invalid_ssid_filter'));
	}
	return dispatchAcknowledgedEvent(SSID_FILTER_EVENT, {
		query: query.trim(),
		resource: 'ssid',
	});
}

/**
 * Focus a resolved SSID.
 * @param {string} entityId opaque SSID identifier
 * @return {Promise<void>} completion acknowledgement
 */
export function focusSsid(entityId) {
	if (typeof entityId !== 'string' || !entityId) {
		return Promise.reject(new Error('invalid_ssid_entity'));
	}
	return dispatchAcknowledgedEvent(SSID_FOCUS_EVENT, {
		entityId,
		resource: 'ssid',
	});
}
